import { render } from "./TraineeImportSuccessful.vue?vue&type=template&id=5feddeb4&scoped=true"
import script from "./TraineeImportSuccessful.vue?vue&type=script&lang=js"
export * from "./TraineeImportSuccessful.vue?vue&type=script&lang=js"

import "./TraineeImportSuccessful.vue?vue&type=style&index=0&id=5feddeb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5feddeb4"]])

export default __exports__